const some = (...args) => args.some(item => !!item)

export default some
